import React, { useEffect, useState, forwardRef } from "react";
import { Input, Select, Button, Form, Card } from "antd";
import FeatherIcon from "feather-icons-react";
import { X, PlusCircle } from "react-feather";
import {
  fetchBrandsBySelectedClients,
  fetchCallCentersByBrand,
  createCallCenter,
  createPhoneNumber,
} from "../../core/api/settings";
import { useSelector } from "react-redux";
import AddCategory from "../../core/modals/inventory/addcategory";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
const { Option } = Select;

const AddPhoneNumber = forwardRef(
  ({ isVisible, onClose, onResize, fetchPhoneNumbers, clientId }, ref) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [form] = Form.useForm();
    const [brands, setBrands] = useState([]);
    const [callCenters, setCallCenters] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [selectedCallCenter, setSelectedCallCenter] = useState(null);

    const data = useSelector((state) => state.toggle_header);
    const [modalProps, setModalProps] = useState({
      title: "",
      onSubmit: null,
    });
    useEffect(() => {
      const sidebarWidth = isFullScreen ? window.innerWidth * 0.6 : 555;
      onResize(sidebarWidth);
    }, [isFullScreen, onResize]);

    const handleAddCallCenter = async (callCenterName) => {
      try {
        if (selectedBrand) {
          const response = await createCallCenter({
            name: callCenterName,
            brand: selectedBrand,
          });
          setCallCenters((prev) => [...prev, response.data]);
        }
      } catch (err) {
        console.error("Failed to create new supplier type", err);
      }
    };

    useEffect(() => {
      const fetchBrands = async () => {
        try {
          if (clientId) {
            const response = await fetchBrandsBySelectedClients([clientId]);
            setBrands(response.data);
          }
        } catch (err) {
          console.error("Failed to fetch brands", err);
        }
      };

      fetchBrands();
    }, [clientId]);

    const handleBrandChange = async (brandId) => {
      setSelectedBrand(brandId);
      setSelectedCallCenter(null);
      form.setFieldsValue({ call_center_id: null });
      setCallCenters([]);

      if (!brandId) {
        return;
      }

      try {
        const response = await fetchCallCentersByBrand(brandId);
        setCallCenters(response.data);
      } catch (err) {
        console.error("Failed to fetch call centers for brand:", err);
      }
    };

    const handleSubmit = async () => {
      try {
        await createPhoneNumber({
          call_center: selectedCallCenter,
          phone_number: form.getFieldValue("phone_number"),
        });
        form.setFieldsValue({ phone_number: "" });
        fetchPhoneNumbers;
      } catch (err) {
        console.error("Failed to save phone number", err);

        // Check for the specific error response indicating duplicate phone number
        if (
          err.response &&
          err.response.data &&
          err.response.data.phone_number &&
          Array.isArray(err.response.data.phone_number) &&
          err.response.data.phone_number[0] ===
            "phone number with this phone number already exists."
        ) {
          Swal.fire({
            title: "Warning",
            text: "The phone number already exists. Please add a different number.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          // Handle other errors
          Swal.fire({
            title: "Error",
            text: "An unexpected error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    };
    const phoneRegex =
      /^(\+?[1-9]{1,3})?[-. (]*\d{2,4}[-. )]*\d{3,4}[-. ]*\d{3,4}(?: *x\d{1,5})?$/;

    return (
      <div
        ref={ref}
        className={`right-sidebar ${isVisible ? "visible" : ""}`}
        style={{
          position: "fixed",
          top: data ? 0 : 66,
          right: 0,
          height: "100%",
          zIndex: 1050,
          width: isFullScreen ? "60%" : "555px",
          backgroundColor: "#fff",
          boxShadow: "0 0 3px rgba(0, 0, 0, 0.6)",
          overflowY: "auto",
          transition: "transform 0.3s ease-in-out",
          transform: isVisible ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <div
          className="sidebar-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h5>Add Phone Number</h5>
          <div>
            <button
              onClick={() => setIsFullScreen(!isFullScreen)}
              className="btn"
            >
              <FeatherIcon icon={isFullScreen ? "minimize" : "maximize"} />
            </button>
            <button
              className="btn"
              onClick={() => {
                onClose();
                form.resetFields();
              }}
            >
              <X />
            </button>
          </div>
        </div>

        <div className="modal-body" style={{ padding: "15px" }}>
          <Form form={form} layout="vertical">
            <Card title="Phone Number Details">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                }}
              >
                {/* Select Brand */}
                <Form.Item
                  label="Select Brand"
                  name="brand_id"
                  rules={[{ required: true, message: "Please select a brand" }]}
                >
                  <Select
                    placeholder="Select Brand"
                    onChange={handleBrandChange}
                    allowClear
                  >
                    {brands.map((brand) => (
                      <Option key={brand.id} value={brand.id}>
                        {brand.brand_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Select Call Center"
                  name="call_center_id"
                  rules={[
                    { required: true, message: "Please select a call center" },
                  ]}
                >
                  <Select
                    placeholder="Select Call Center"
                    allowClear
                    disabled={!selectedBrand}
                    key={selectedBrand}
                    onChange={(value) => setSelectedCallCenter(value)}
                  >
                    {callCenters.map((center) => (
                      <Option key={center.id} value={center.id}>
                        {center.name}
                      </Option>
                    ))}
                  </Select>
                  <Link
                    hidden={!selectedBrand}
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#add-units-category"
                    onClick={() =>
                      setModalProps({
                        title: "Call Center",
                        onSubmit: async (name) => {
                          await handleAddCallCenter(name);
                        },
                      })
                    }
                  >
                    <PlusCircle className="plus-down-add" />
                    <span>Add New Call Center</span>
                  </Link>
                </Form.Item>

                <Form.Item
                  label="Phone Number"
                  name="phone_number"
                  rules={[
                    { required: true, message: "Please enter a phone number" },
                    {
                      pattern: phoneRegex,
                      message: "Invalid phone number format",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Phone Number"
                    disabled={!selectedBrand || !selectedCallCenter}
                  />
                </Form.Item>

                <div>
                  <Button
                    type="primary"
                    className="btn btn-primary mt-4"
                    onClick={handleSubmit}
                    icon={<PlusCircle className="me-0 iconsize" />}
                    disabled={!selectedBrand || !selectedCallCenter}
                  >
                    Add Phone Number
                  </Button>
                </div>
              </div>
            </Card>

            <div style={{ textAlign: "right", marginTop: "20px" }}>
              <Button
                type="primary"
                className="btn btn-primary"
                onClick={onClose}
              >
                Done
              </Button>
            </div>
          </Form>
        </div>
        <AddCategory {...modalProps}></AddCategory>
      </div>
    );
  }
);

AddPhoneNumber.displayName = "AddPhoneNumber";

export default AddPhoneNumber;
